<template>
  <v-form ref="form" v-model="valid" @submit.prevent="">
    <v-row align="start" justify="start" dense>
      <v-col cols="12" :sm="hideProduct ? 12 : 6" v-if="!hideDate">
        <RangeDatePicker
          :value="period"
          @input="v => onPeriodChange(v)"
          label="Période"
          no-before
          filled
          dense
          class="no-before"
          hide-details
        ></RangeDatePicker>
      </v-col>
      <v-col cols="12" :sm="hideDate ? 12 : 6" v-if="!hideProduct">
        <v-autocomplete
          class="no-before"
          hide-details
          :items="getProducts.filter(x => x.is_deleted === false)"
          item-value="id"
          item-text="nom"
          :value="productFilter"
          filled
          dense
          @change="v => onProductChange(v)"
          label="Produit"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { RangeDatePicker } from "@/modules/Shared";
export default {
  name: "StatisticsFilter",
  components: {
    RangeDatePicker
  },
  props: {
    take: {
      required: true
    },
    productFilter: {
      required: true
    },
    start: {
      required: true
    },
    end: {
      required: true
    },
    groupBy: {
      required: true
    },
    period: {
      required: true
    },
    hideProduct: {
      type: Boolean,
      default: false
    },
    hideDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getProducts"])
  },
  data() {
    return {
      valid: false,
      periodSelection: [{ value: "last7Days", text: "Dernier 7 jours" }]
    };
  },
  methods: {
    search() {
      this.$emit("search");
    },
    onProductChange(value) {
      this.$emit("update:productFilter", value);
    },
    onPeriodChange(value) {
      this.$emit("update:period", value);
      if (value.length === 2) {
        const start = moment(value[0]);
        const end = moment(value[1]);
        this.$emit("update:start", start.format("YYYY-MM-DD"));
        this.$emit("update:end", end.format("YYYY-MM-DD"));
      }
    }
  }
};
</script>

<style></style>
